module.exports = __webpack_public_path__ + "static/img/business1.84fd3a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business1.jpg
// module id = gf4r
// module chunks = 9